import { createSlice } from "@reduxjs/toolkit";

const OriginalDeedModalSlice = createSlice({
  name: "originalDeed",
  initialState: {
    formData: {
      refDafa60: "",
      refSrocode: "",
      refRegdate: "",
      refRegno: "",
    },
    show: false, // Add the show state to control the visibility of the modal
  },
  reducers: {
    setFormData(state, action) {
      state.formData = { ...state.formData, ...action.payload };
    },
    resetOriginalDeedModalData(state) {
      state.formData = {
        refDafa60: "",
        refSrocode: "",
        refRegdate: "",
        refRegno: "",
      };
    },
    // Action to show the modal
    showModal(state) {
      state.show = true;
    },
    // Action to hide the modal
    hideModal(state) {
      state.show = false;
    },
    setInitialDeedFormData(state, action) {
      state.formData = action.payload;
    },
  },
});

export const {
  setFormData,
  resetOriginalDeedModalData,
  showModal,
  hideModal,
  setInitialDeedFormData,
} = OriginalDeedModalSlice.actions;

export default OriginalDeedModalSlice.reducer;
